import { ExecutionStatRecord, StatRecord } from "@dashboard-v3/api";
import reduce90Days from "../reduce90Days";

type Totals = ReturnType<typeof emptyResults>;
export type EmailsSumData = Array<{ date: number } & Totals>;

export function parseData(data: Array<StatRecord>): EmailsSumData {
  return reduce90Days<Totals>(
    data,
    "executions",
    emptyResults,
    (totals, stat) => {
      const record = stat as ExecutionStatRecord[];

      for (const { ruleAction, targetType, total } of record) {
        const actionKey = ruleAction.toLowerCase();
        const targetsKey = targetType.toLowerCase();
        totals[actionKey] = (totals[actionKey] || 0) + total;
        totals[targetsKey] = (totals[targetsKey] || 0) + total;
        totals.all = (totals.all || 0) + total;
      }

      return totals;
    }
  );
}

function emptyResults() {
  return {
    drag_and_drop: 0,
    replace_attachments: 0,
    protect_emails: 0,
    move_emails: 0,
    copy_emails: 0,
    block_attachments: 0,
    email_flow: 0,
    archiving_address: 0,
    mail_box: 0,
    storage_webhook: 0,
    request_approval: 0,
    send_delay: 0,
    zip_attachments: 0,
    smime_emails: 0,
    all: 0,
  };
}
